import React from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';
import transferPlaceholder from '../../hoc/transferPlaceholder';

import { NavigationTabsBuilder } from '../builder/NavigationTabs';
import BuilderSidebar from '../builder/BuilderSidebar';
import Model from '../builder/Model';
import Checkbox from '../builder/Checkbox';
import { AutoPostImageUploader } from '../builder/ImageUploader';
import RichEditor from '../builder/RichEditor';
import Input from '../builder/Input.js';
import Layout from '../front/Layout.js';
import BuilderCanvas from '../builder/BuilderCanvas.js';

const InputPlaceHolder = injectIntl(transferPlaceholder(Input));

const GameInstructionsBuilder = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const start_button_label = i18n("Label for '%s' button").replace('%s', i18n("Start"));
	const instructions_disabled = stage?.instructions_disabled ?? false;

	return (
		<>
			<BuilderSidebar onSave={props.saveStage}>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<Model model={stage} change={change}>
					<Checkbox 
						name="instructions_disabled"
						_class={{ first:true }}
					>Disable instructions</Checkbox>
				</Model>

				{(instructions_disabled === false) && (
					<Model model={stage} change={change}>
						<AutoPostImageUploader
							auto_url={`/promotions/auto_img/${props.promotion.id}`}
							auto_type='stages'
							name="instructions_img"
							image={stage.full_instructions_img}
							display_custom_dragging_instructions="Upload the image"
							small_input={true}
							_size={{ fit:'auto' }}
						>Image</AutoPostImageUploader>

						<RichEditor
							name="instructions_description"
							has_emojis={true}
						>Description</RichEditor>

						<InputPlaceHolder
							name="instructions_button"
							placeholder={i18n("Start")}
							autotranslate={false}
						>{start_button_label}</InputPlaceHolder>
					</Model>
				)}
			</BuilderSidebar>

			{(instructions_disabled === false) ? (
				<BuilderCanvas
					fit_to_window="content"
				>
					<Layout
						promo={props.promotion}
						is_builder={true}
						page="quiz"
						menus={props.promoModel.Custom__Menus}
						layout_extra_classes="is_new_game"
					>
						<div class="____gui_withoutEvents" style={{ width:'100%' }}>
							{props.children}
						</div>
					</Layout>
				</BuilderCanvas>
			) : (
				<BuilderCanvas
					fit_to_window="content"
					bordered={false}
					not_awesome={true}
				>
					<p>{i18n("Instructions are disabled.")}</p>
				</BuilderCanvas>
			)}
		</>
	)
};

export default injectIntl(GameInstructionsBuilder);